var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WithTitle',{attrs:{"title":_vm.$t('tab.instructions')}},[(_vm.instructions.length)?_c('ProductInstructions',{attrs:{"instructions":_vm.instructions}}):_c('Loader',{attrs:{"without-opacity":"","is-loading":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }